var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/Footer/AuthedFooter.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Grid } from '@wds/grid';
import { Box } from '@wds/box';
import classnames from 'classnames';
import { LanguageMenuLI } from './LanguageMenu';
import { AuthedFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import BillingAddress from './BillingAddress';
import { SMFooterContext } from './SMFooterContext';
import useStyles from './useStyles';
var AuthedFooter = function AuthedFooter() {
  var _useContext = useContext(SMFooterContext),
    _useContext$domain = _useContext.domain,
    domain = _useContext$domain === void 0 ? '' : _useContext$domain,
    _useContext$lang = _useContext.lang,
    lang = _useContext$lang === void 0 ? '' : _useContext$lang,
    country = _useContext.country,
    variant = _useContext.variant,
    showBillingAddress = _useContext.showBillingAddress;
  var _useStyles = useStyles(),
    footerAuth = _useStyles.footerAuth;
  var footerClassNames = classnames(footerAuth, 'sm-footer');
  return /*#__PURE__*/React.createElement("div", {
    className: footerClassNames,
    "data-testid": "AuthedFooter",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: variant === 'center' ? 'center' : 'flex-start',
    flexDirection: "column",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LanguageMenuLI, {
    lang: lang,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 13
    }
  })))), /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: variant === 'center' ? 'center' : 'flex-start',
    flexDirection: "column",
    my: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(AuthedFooterLinks, {
    domain: domain,
    lang: lang,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 13
    }
  }), showBillingAddress && /*#__PURE__*/React.createElement(BillingAddress, {
    country: country,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 36
    }
  })))), /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Grid.Item, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexAlign: variant === 'center' ? 'center' : 'flex-start',
    flexDirection: "column",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(TrusteSeals, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  })))));
};
export default AuthedFooter;
//# sourceMappingURL=AuthedFooter.js.map